export default {
	back_to_intel_retail_edge_program: "Retour au Intel® Retail Edge Program",
	other_names_and_brands_could_be_claimed_as_third_party_property: "D’autres noms et marques pourraient être revendiqués comme propriété de tiers.",
	trademarks: "Marques Déposées"
}
